// extracted by mini-css-extract-plugin
module.exports = {"pagination":"data-table_pagination__2AzPe","noSearchResultRender":"data-table_noSearchResultRender__2eTYT","okayGotIt":"data-table_okayGotIt__e66tl"};